module.exports = __webpack_public_path__ + "img/altus-corp.1889fa17.jpeg";